export default {
    translation: {
        common: {
            confirm: '确认',
            cancel: '取消',
            save: '保存',
            saving: '保存中...',
            loading: '加载中...',
            error: '错误',
            success: '成功',
            confirmLogout: '确定要退出登录吗？',
            close: '关闭',
            previous: '上一页',
            next: '下一页',
            retry: '重试',
            back: '返回',
            submit: '提交',
            update: '更新',
            submitting: '提交中...',
            optional: '可选',
            loginRequired: '请先登录',
            edit: '编辑',
            delete: '删除',
            deleting: '删除中...',
            exporting: '导出中...',
            select: '请选择'
        },
        auth: {
            login: '登录',
            register: '注册',
            logout: '退出',
            email: '邮箱',
            password: '密码',
            username: '用户名',
            loginPage: {
                title: '登录账号',
                subtitle: 'Sign in to your account',
                emailLabel: '邮箱',
                emailPlaceholder: 'your@email.com',
                passwordLabel: '密码',
                passwordPlaceholder: '••••••••',
                signInButton: '登录',
                signingIn: '登录中...',
                googleSignIn: '使用 Google 账号登录',
                noAccount: '还没有账号？',
                register: '立即注册',
                forgotPassword: '忘记密码？',
                resetPassword: {
                    title: '重置密码',
                    description: '请输入您的邮箱，我们将向您发送重置密码的链接。',
                    emailSent: '重置密码邮件已发送，请查看您的邮箱。',
                    submit: '发送重置链接',
                    back: '返回登录',
                    errors: {
                        userNotFound: '该邮箱未注册',
                        invalidEmail: '邮箱格式不正确',
                        default: '发送失败，请稍后重试'
                    }
                },
                errors: {
                    invalidEmail: '邮箱格式不正确',
                    userNotFound: '用户不存在',
                    wrongPassword: '密码错误',
                    default: '登录失败，请稍后重试',
                    googleSignIn: 'Google 登录失败，请稍后重试'
                }
            },
            registerPage: {
                title: '创建账号',
                subtitle: 'Create your account',
                usernameLabel: '用户名',
                usernamePlaceholder: '请输入用户名',
                emailLabel: '邮箱',
                emailPlaceholder: 'your@email.com',
                passwordLabel: '密码',
                passwordPlaceholder: '••••••••',
                registerButton: '注册',
                registering: '注册中...',
                hasAccount: '已有账号？',
                login: '立即登录',
                success: {
                    message: '注册成功！我们已向您的邮箱发送了一封验证邮件，请查收并验证后登录。'
                },
                errors: {
                    emailInUse: '该邮箱已被注册',
                    invalidEmail: '邮箱格式不正确',
                    weakPassword: '密码强度不足',
                    default: '注册失败，请稍后重试'
                }
            }
        },
        profile: {
            editUsername: {
                title: '修改用户名',
                placeholder: '请输入新的用户名',
                empty: '用户名不能为空',
                lengthError: '用户名长度应在2-20个字符之间',
                updateFailed: '更新失败，请重试'
            },
            title: '个人中心',
            subtitle: 'Profile Center',
            loading: '加载中',
            userNotFound: '未找到用户信息，请联系管理员',
            backToLogin: '返回登录',
            schedule: {
                title: '我的课程表',
                subtitle: 'My Schedule',
                adminNoSchedule: '管理员无课程表',
                adminNoScheduleHint: 'No schedule for admin'
            },
            information: '个人信息',
            email: {
                label: '邮箱',
                verified: '已验证',
                unverified: '未验证 - 点击验证'
            },
            role: {
                label: '角色',
                student: '学生',
                teacher: '教师',
                admin: '管理员'
            },
            status: {
                label: '状态',
                active: '正常',
                inactive: '已禁用'
            },
            verifyEmail: {
                dialogTitle: '发送验证邮件',
                dialogMessage: '我们将向您的邮箱发送一封验证邮件，请注意查收。是否继续？',
                send: '发送',
                cancel: '取消',
                successTitle: '发送成功',
                successMessage: '验证邮件已发送，请查看您的邮箱并点击验证链接。',
                errorTitle: '发送失败',
                errorMessage: '验证邮件发送失败，请稍后重试。',
                confirm: '知道了',
                ok: '确定'
            },
            changePassword: {
                title: '修改密码',
                oldPassword: '当前密码',
                newPassword: '新密码',
                confirmPassword: '确认新密码',
                submit: '确认修改',
                cancel: '取消',
                success: '密码修改成功',
                errors: {
                    wrongPassword: '当前密码错误',
                    passwordMismatch: '两次输入的新密码不一致',
                    weakPassword: '新密码强度不足',
                    default: '修改失败，请稍后重试'
                }
            },
            myRegistrations: '我的报名记录',
            noRegistrations: '您尚未报名任何课程',
            registrationsFetchError: '获取报名记录失败，请稍后再试',
            registrationId: '报名编号',
            registrationDate: '报名日期',
            totalPrice: '总价（含管理费）',
            earlyBirdPrice: '早鸟价（在打折截止日期前）',
            amountPaid: '已支付金额',
            moreCourses: '浏览更多课程',
            selectedDates: '已选日期',
            registrationStatus: {
                label: '报名状态',
                pending: '待审核',
                approved: '已通过',
                rejected: '已拒绝',
                waitlisted: '候补名单',
                cancelled: '已取消'
            },
            paymentStatus: {
                label: '支付状态',
                unpaid: '未支付',
                paid: '已支付',
                refunded: '已退款',
                partial: '部分支付'
            },
            paymentMethod: {
                label: '支付方式',
                cash: '现金',
                creditCard: '信用卡',
                bankTransfer: '银行转账',
                wechat: '微信支付',
                alipay: '支付宝',
                other: '其他'
            },
            paymentDate: '支付日期',
            receipt: '支付收据',
            viewReceipt: '查看收据',
            noReceipt: '暂无收据',
            uploadReceipt: '上传收据',
            myCourses: '我的课程',
            noCourses: '您还没有课程',
            coursesFetchError: '获取课程失败',
            today: '今天',
            nextClass: '下一堂课',
            location: '地点',
            students: '学生',
            markAttendance: '标记出勤',
            courseStatus: {
                active: '进行中',
                pending: '即将开始',
                completed: '已完成',
                cancelled: '已取消'
            },
            activeCourses: '进行中的课程',
            noActiveCourses: '您没有进行中的课程',
            viewAllCourses: '查看所有课程',
            todaySchedule: '今日课程表',
            moreDates: '更多日期',
            coursesLabel: '课程',
            courseLabel: '课程',
        },
        header: {
            brand: {
                name: '万湖书院',
                subtitle: 'Great Lakes Academy'
            },
            nav: {
                home: '首页',
                programs: '课程',
                news: '新闻'
            },
            userMenu: {
                profile: '个人中心',
                signOut: '退出登录'
            },
            mobileMenu: {
                close: '关闭菜单'
            },
            language: {
                en: 'English',
                zh: '中文'
            },
            subnav: {
                title: '快速导航',
                home: '万湖主页',
                about: '学校简介',
                calendar: '学校校历',
                projects: '项目简介',
                teachers: '教师风采',
                contact: '联系我们',
                donate: '支持我们'
            }
        },
        hero: {
            title: '万湖书院',
            subtitle: '在万湖书院开启您的中文学习之旅',
            description: '我们提供专业的中文教学课程，帮助您掌握中文语言技能，了解中国文化。',
            cta: {
                primary: '开始学习',
                secondary: '了解更多'
            },
            stats: {
                students: {
                    value: '1000+',
                    label: '在校学生'
                },
                courses: {
                    value: '50+',
                    label: '精品课程'
                },
                teachers: {
                    value: '20+',
                    label: '专业教师'
                }
            },
            news: {
                title: '最新动态',
                more: '查看更多',
                empty: '暂无新闻'
            },
            notice: {
                title: '通知公告',
                more: '查看更多',
                empty: '暂无公告'
            },
            new: {
                badge: 'Inherit Inspire Innovate Influence',
                title: '万湖书院',
                description: '在万湖书院开启您的中文学习之旅',
                cta: {
                    primary: '开始学习',
                    secondary: '了解更多'
                }
            }
        },
        features: {
            title: '我们的特色',
            subtitle: '为什么选择万湖书院？',
            items: {
                curriculum: {
                    title: '专业课程体系',
                    description: '我们提供系统化的中文教学课程，从入门到高级，满足不同学习需求。'
                },
                schedule: {
                    title: '灵活的学习时间',
                    description: '提供多样化的课程安排，让您可以根据自己的时间灵活安排学习。'
                },
                community: {
                    title: '活跃的学习社区',
                    description: '加入我们的学习社区，与来自世界各地的学习者交流互动。'
                }
            }
        },
        message: {
            title: '教学理念',
            subtitle: '我们的承诺',
            content: {
                title: '致力于通过丰富多样的课程体系，在快乐学习中传递优质教育。',
                description: '万湖书院致力于营造一个支持性、充满活力的学习环境，让学生能够探索热情所在、培养新技能、充分发挥潜能。我们不仅注重提供趣味盎然的优质中文教育，还开设数学、编程等多元化课程。我们以激发好奇心、培养创造力、尊重多样性为宗旨，鼓励学生建立超越课堂的终身学习理念，为未来的学术与人生发展奠定坚实基础。',
                highlight: '让每个学生都能在这里找到学习的乐趣，收获知识的力量。'
            }
        },
        programs: {
            section: {
                title: '精品课程',
                subtitle: '探索我们的课程体系',
                items: {
                    saturday: {
                        title: '周六课程',
                        description: '我校每周六开设中文、数学及其它拓展课程，让学生在周末既能学习中文，又能全面提升多学科技能。',
                        level: '全级别',
                        duration: '每周一次',
                        action: '了解详情'
                    },
                    afternoon: {
                        title: '课后班',
                        description: '我校每天在公立学校放学后提供中文课程，帮助学生们利用课后时间系统学习中文，通过日常练习稳步提升语言能力。',
                        level: '全级别',
                        duration: '每周多次',
                        action: '了解详情'
                    },
                    summer: {
                        title: '夏令营',
                        description: '暑期沉浸式中文学习体验，结合文化活动和语言学习。',
                        level: '全级别',
                        duration: '1-8周',
                        action: '了解详情'
                    },
                    online: {
                        title: '在线课程',
                        description: '灵活的在线学习选项，随时随地学习中文。',
                        level: '全级别',
                        duration: '自定进度',
                        action: '了解详情'
                    }
                }
            }
        },
        testimonials: {
            title: '家长反馈',
            subtitle: '听听他们怎么说',
            items: [
                {
                    content: '在万湖学院学习中文是一段非常愉快的经历。老师们都很专业，课程安排也很合理，让我在短时间内就有了明显的进步。',
                    author: {
                        name: 'Sarah Chen',
                        role: '初级班学员',
                        company: '来自美国'
                    }
                },
                {
                    content: '作为一个零基础的学习者，我很感激万湖学院提供的系统化学习方案。课程内容生动有趣，让学习中文变得轻松愉快。',
                    author: {
                        name: 'Michael Wang',
                        role: '中级班学员',
                        company: '来自加拿大'
                    }
                },
                {
                    content: '高级课程的商务中文部分对我的工作帮助很大。现在我可以自信地用中文进行商务交流了。',
                    author: {
                        name: 'Emma Liu',
                        role: '高级班学员',
                        company: '来自英国'
                    }
                }
            ]
        },
        footer: {
            about: {
                title: '关于我们',
                description: '万湖书院致力于为学生提供高质量的中文教育，同时提供数学、编程等多元化课程。'
            },
            links: {
                title: '快速链接',
                items: {
                    home: '首页',
                    about: '关于我们',
                    programs: '课程',
                    contact: '联系我们',
                    donate: '支持我们'
                }
            },
            contact: {
                title: '联系方式',
                address: '3300 Plymouth Blvd # 46253 Plymouth, MN 55447',
                phone: '(952) 546-1000',
                email: 'info@greatlakesacademy.ca'
            },
            social: {
                title: '关注我们',
                items: {
                    facebook: '脸书',
                    twitter: '推特',
                    instagram: '照片墙',
                    linkedin: '领英'
                }
            },
            copyright: '© 2025 万湖书院. 保留所有权利。'
        },
        programsList: {
            hero: {
                title: '课程项目',
                description: '探索我们丰富多彩的项目内容',
                browseButton: '浏览课程'
            },
            categories: {
                all: '所有课程',
                saturday: '周末课程',
                afterSchool: '课后辅导',
                summerCamp: '夏令营',
                satAct: '网课',
                volunteer: '志愿者'
            },
            status: {
                loading: '加载中...',
                empty: {
                    title: '精彩内容即将上线',
                    subtitle: '请稍后再试'
                },
                showActive: '显示进行中的课程',
                active: '进行中',
                inactive: '已结束'
            },
            loadMore: {
                text: '加载更多',
                loading: '加载中...',
                button: '加载更多'
            }
        },
        programCard: {
            status: {
                active: '进行中',
                inactive: '已结束',
                upcoming: '即将开始'
            }
        },
        program: {
            backToList: '返回列表',
            publishDate: '发布日期',
            category: '分类',
            status: '状态',
            notFound: '项目不存在',
            notFoundDesc: '抱歉，您查找的项目不存在或已被删除。',
            loginRequired: '请先登录后再报名课程',
            noCourses: '暂无相关课程',
            availableCourses: '可选课程',
            availableCamps: '可选夏令营',
            categories: {
                saturday: '周末课程',
                afterSchool: '课后辅导',
                summerCamp: '夏令营',
                satAct: '网课',
                volunteer: '志愿者'
            },
            statuses: {
                active: '进行中',
                inactive: '已结项',
                upcoming: '即将开始',
                draft: '草稿'
            }
        },
        course: {
            duration: '课时长度',
            minutes: '分钟',
            schedule: '课程安排',
            moreSchedules: '还有 {count} 个课时',
            enroll: '立即报名',
            canNotEnroll: '报名期限已过',
            loading: '加载中...',
            notFound: '课程未找到',
            fetchError: '获取课程信息失败',
            allowCustomSchedule: '允许自选上课时间',
            fixedSchedule: '固定上课时间',
            scheduleSelectionDisabled: '该课程不允许自选上课时间，将按照预设的课程安排上课',
            scheduleSelectionEnabled: '您可以根据自己的时间安排选择上课日期',
            enrollmentOpen: '可报名',
            enrollmentClosed: '报名已截止',
        },
        registration: {
            required: '此项目必选至少一项',
            title: '报名',
            totalPrice: '总价（含管理费）',
            earlyBirdPrice: '早鸟价',
            afterDiscountDate: '在{{date}}后付款',
            beforeDiscountDate: '在{{date}}当天或者之前付款',
            discountDeadline: '打折截止日期',
            program: '项目',
            selectCourses: '选择课程',
            noCoursesAvailable: '暂无可选课程',
            noCourseSelected: '请至少选择一门课程',
            requiredCoursesNotSelected: '请选择所有必选课程组',
            studentInfo: '学生信息',
            firstName: '名字',
            lastName: '姓',
            chineseName: '中文名',
            gender: '性别',
            selectGender: '请选择性别',
            male: '男',
            female: '女',
            other: '其他',
            dateOfBirth: '出生日期',
            grade: '年级',
            selectGrade: '请选择年级',
            fullTimeSchoolName: '全日制学校名称（*课后班必填）',
            fullTimeSchoolNamePlaceholder: '请填写全日制学校名称',
            grades: {
                kindergarten: '幼儿园',
                grade1: '一年级',
                grade2: '二年级',
                grade3: '三年级',
                grade4: '四年级',
                grade5: '五年级',
                grade6: '六年级',
                grade7: '七年级',
                grade8: '八年级',
                grade9: '九年级',
                grade10: '十年级',
                grade11: '十一年级',
                grade12: '十二年级',
                other: '其他'
            },
            allergies: '过敏史',
            allergiesPlaceholder: '请填写学生的过敏信息，如食物、药物等（选填）',
            parentInfo: '家长/监护人信息',
            parentFirstName: '家长名字',
            parentLastName: '家长姓',
            phone: '联系电话',
            email: '电子邮箱',
            address: '地址',
            addressPlaceholder: '街道号码和名称',
            aptNumber: '门牌号',
            aptNumberPlaceholder: '公寓/单元号（选填）',
            city: '城市',
            state: '州',
            zipCode: '邮编',
            emergencyContact: '紧急联系人',
            emergencyFirstName: '名字',
            emergencyLastName: '姓',
            emergencyPhone: '电话',
            emergencyEmail: '邮箱',
            emergencyAddress: '地址',
            emergencyAddressPlaceholder: '街道号码和名称',
            emergencyAptNumber: '门牌号',
            emergencyAptNumberPlaceholder: '公寓/单元号（选填）',
            emergencyCity: '城市',
            emergencyState: '州',
            emergencyZipCode: '邮编',
            additionalInfo: '其他信息',
            parentMessage: '家长留言',
            parentMessagePlaceholder: '如有其他需要说明的情况，请在此填写（选填）',
            submit: '提交报名',
            submitting: '提交中...',
            cancel: '取消',
            
            // 验证错误信息
            firstNameRequired: '请填写名字',
            lastNameRequired: '请填写姓',
            genderRequired: '请选择性别',
            dateOfBirthRequired: '请选择出生日期',
            gradeRequired: '请选择年级',
            parentFirstNameRequired: '请填写家长名字',
            parentLastNameRequired: '请填写家长姓',
            phoneRequired: '请填写联系电话',
            invalidPhone: '请输入有效的电话号码',
            emailRequired: '请填写电子邮箱',
            invalidEmail: '请输入有效的电子邮箱',
            addressRequired: '请填写地址',
            cityRequired: '请填写城市',
            stateRequired: '请填写州',
            zipCodeRequired: '请填写邮编',
            emergencyFirstNameRequired: '请填写紧急联系人名字',
            emergencyLastNameRequired: '请填写紧急联系人姓',
            emergencyPhoneRequired: '请填写紧急联系人电话',
            invalidEmergencyPhone: '请输入有效的紧急联系人电话',
            emergencyEmailRequired: '请填写紧急联系人邮箱',
            invalidEmergencyEmail: '请输入有效的紧急联系人邮箱',
            emergencyAddressRequired: '请填写紧急联系人地址',
            emergencyCityRequired: '请填写紧急联系人城市',
            emergencyStateRequired: '请填写紧急联系人州',
            emergencyZipCodeRequired: '请填写紧急联系人邮编',
            
            // 错误信息
            programNotFound: '项目不存在',
            courseNotFound: '课程不存在',
            noProgramSelected: '未选择项目',
            fetchError: '获取数据失败，请稍后再试',
            submitError: '提交报名失败，请稍后再试',
            
            // 协议确认
            agreementTitle: '协议确认',
            agreementDescription: '请仔细阅读以下协议内容，点击"同意并继续"表示您已阅读并同意该协议。',
            agreementProgress: '第 {current} 个协议，共 {total} 个',
            agreeAndNext: '同意并继续',
            agreeAll: '同意并继续',
            continue: '继续',
            previous: '上一个',
            noAgreements: '没有需要确认的协议',
            agreementFetchError: '获取协议失败，请稍后再试',
            skipAgreements: '跳过协议确认',
            agreements: {
                terms: {
                    title: '条款和条件',
                    version: '1.0',
                    instruction: '在继续注册之前，请阅读并同意以下条款和条件。'
                },
                privacy: {
                    title: '隐私政策',
                    version: '1.0',
                    instruction: '在继续注册之前，请阅读并同意我们的隐私政策。'
                },
                liability: {
                    title: '免责声明',
                    version: '1.0',
                    instruction: '在继续注册之前，请阅读并同意免责声明。'
                },
                photo: {
                    title: '照片/视频发布授权',
                    version: '1.0',
                    instruction: '在继续注册之前，请阅读并同意照片和视频发布协议。'
                },
                medical: {
                    title: '医疗授权',
                    version: '1.0',
                    instruction: '在继续注册之前，请阅读并同意医疗授权表。'
                }
            },
            
            // 成功信息
            submitSuccess: '报名提交成功！',
            redirecting: '正在跳转到成功页面...',
            backToPrograms: '返回项目列表',
            selectDates: '选择课程日期',
            selectAll: '全选',
            deselectAll: '取消全选',
            selectedDays: '已选择天数',
            unitPrice: '单日价格',
            previousInfoUsed: '已使用您之前的报名信息',
            checkAndUpdate: '请检查并根据需要更新信息',
            fetchDataError: '获取数据失败，请稍后再试',
            unknownProgram: '未知项目',
            unknownCourse: '未知课程',
            
            // 课程选择
            multipleCourseSelection: '请选择您想要报名的课程。',
            singleCourseAvailable: '您可以选择这组课里的一个课程。',
            selectedCourses: '已选择的课程',
            addNew: '新增报销',
            createFirst: '创建第一条报销记录',
            noRecords: '暂无报销记录',
            notFound: '未找到报销记录',
            deleteConfirm: '确定要删除此报销记录吗？',
            deleteSuccess: '删除成功',
            deleteError: '删除失败，请稍后重试',
            viewAll: '查看全部',
            allReimbursements: '全部报销记录',
            filterByStatus: '按状态筛选',
            allStatuses: '全部状态',
            showingReimbursements: '显示 {{start}} 到 {{end}} 条，共 {{total}} 条',
            noReimbursementsWithStatus: '没有{{status}}状态的报销记录',
            status: {
                pending: '待审核',
                approved: '已批准',
                rejected: '已拒绝',
                paid: '已支付'
            },
            types: {
                teaching_materials: '教学材料',
                travel: '差旅费',
                office_supplies: '办公用品',
                equipment: '设备',
                other: '其他'
            },
            noReceipts: '暂无收据',
            reviewComment: '审核意见',
            uploadReceipts: '上传收据',
            uploadDocuments: '上传文档',
            dragAndDrop: '或拖拽文件到此处',
            preview: '预览',
            new: '新',
            existingDocuments: '已上传的文档',
            newDocuments: '新上传的文档',
        },
        registrationSuccess: {
            title: '报名成功！详情请查看邮件。',
            subtitle: '您的课程报名已成功提交，请及时支付费用',
            registrationDetails: '报名详情',
            registrationId: '报名编号',
            programTitle: '项目名称',
            studentName: '学生姓名',
            program: '项目名称',
            course: '课程名称',
            courses: '课程列表',
            noCourseSelected: '未选择课程',
            status: '报名状态',
            pending: '待审核',
            discountDeadline: '打折截止日期',
            priceDetails: '价格详情',
            earlyBirdPrice: '早鸟优惠价',
            regularPrice: '常规价格',
            ifPaidBefore: '在{{date}}前或者当天付款',
            ifPaidAfter: '在{{date}}后付款',
            includingManagementFee: '含管理费',
            paymentOptions: '付款方式',
            option1: '方式一：Zelle转账',
            option2: '方式二：邮寄支票',
            zelleInfo: '请通过Zelle向{email}发送学费',
            zelleNote1: '请在备注栏中填写您的报名编号({registrationId})和学生姓名',
            zelleNote2: 'Zelle支付通常会立即处理',
            zelleNote3: '如有任何支付问题，请联系我们',
            checkInfo: '请将支票抬头写为Great Lakes Academy，并邮寄至以下地址：',
            checkNote: '请务必在支票备注栏中注明您的报名编号({registrationId})和学生姓名',
            nextSteps: '后续步骤',
            step1: '我们将在五个工作日内审核您的缴费信息和报名信息，并发送邮件通知您审核结果',
            step2: '请尽快完成缴费，以免错过课程',
            step3: '审核通过后，您将收到课程确认邮件和上课通知',
            viewProfile: '查看个人中心',
            browsePrograms: '浏览更多项目',
            invalidAccess: '无效访问',
            invalidAccessDesc: '您似乎是直接访问了此页面，请通过正常的报名流程访问。'
        },
        emailVerification: {
            title: '邮箱验证',
            subtitle: '请验证您的邮箱',
            description: '我们已经向您的邮箱发送了一封验证邮件。请查看您的邮箱并点击验证链接以完成验证。',
            checkInbox: '查看邮箱',
            resendEmail: '重新发送验证邮件',
            resendWait: '秒后可重新发送',
            backToProfile: '返回个人中心',
            resendSuccess: '验证邮件已重新发送',
            resendError: '发送失败，请稍后重试',
            cooldown: '{seconds} 秒后可重新发送',
            verifySuccess: '邮箱验证成功',
            verifyError: '验证失败，请重试',
            successMessage: '邮箱验证成功',
            errorMessage: '验证失败，请重试',
            verifyComplete: '我已完成验证',
            verifyChecking: '正在检查验证状态...',
            verifyNotComplete: '邮箱尚未验证，请检查邮箱或重新发送验证邮件',
        },
        gallery: {
            title: '精彩时刻',
            subtitle: '校园生活',
            mainTitle: '激发每个孩子的潜能',
            controls: {
                scrollLeft: '向左滚动',
                scrollRight: '向右滚动',
                pause: '暂停自动滚动',
                play: '开始自动滚动'
            },
            lightbox: {
                previous: '上一张图片',
                next: '下一张图片',
                close: '关闭预览'
            },
            images: {
                drawing: {
                    title: '绘画',
                    description: '学生通过视觉艺术表达创造力并发展精细运动技能'
                },
                music: {
                    title: '音乐',
                    description: '通过多样化的乐器和声乐训练，培养音乐才能和对和谐的欣赏能力'
                },
                science: {
                    title: '科学',
                    description: '通过动手实验和科学探究，探索自然世界的奇妙'
                },
                socialStudies: {
                    title: '社会研究',
                    description: '通过互动学习，理解社会、历史和全球联系'
                },
                teamwork: {
                    title: '团队合作',
                    description: '建立协作技能，学习在小组项目中与同龄人有效合作'
                },
                art: {
                    title: '艺术',
                    description: '通过各种艺术媒介，培养审美敏感性和创造性表达'
                },
                literature: {
                    title: '文学',
                    description: '探索故事、诗歌和文学名著的世界，培养阅读和理解能力'
                },
                sports: {
                    title: '体育教育',
                    description: '通过多样化的体育活动，促进身体健康、团队合作和健康生活方式'
                },
                technology: {
                    title: '科技',
                    description: '为现代世界发展数字素养和计算思维技能'
                },
                language: {
                    title: '语言',
                    description: '掌握多种语言，成为有效的全球沟通者和文化大使'
                },
                mathematics: {
                    title: '数学',
                    description: '通过引人入胜的活动，建立坚实的数字基础和解决问题的能力'
                },
                default: {
                    title: '精彩时刻',
                    description: '万湖书院的精彩瞬间记录'
                }
            },
            cards: [
                {
                    title: '教育理念',
                    description: '我们致力于为每一位学员提供优质的教育资源和学习体验。'
                },
                {
                    title: '专业课程',
                    description: '通过专业的课程设计和教学服务，帮助学员实现个人成长和职业发展。'
                },
                {
                    title: '师资力量',
                    description: '我们拥有一支经验丰富、资质优秀的师资队伍，致力于为学员提供高质量的教学服务。'
                },
                {
                    title: '教学成果',
                    description: '我们的教学成果得到了广大学员和家长的高度认可和赞誉。'
                }
            ]
        },
        teacher: {
            allCourses: '全部课程',
            filterByStatus: '按状态筛选',
            allStatuses: '全部状态',
            noCoursesWithStatus: '没有{{status}}的课程',
            viewStudents: '查看学生',
            showingCourses: '显示 {{start}}-{{end}} 条，共 {{total}} 条',
            courseStudents: '课程学生',
            totalStudents: '学生总数',
            noStudentsInCourse: '该课程暂无学生',
        },
        student: {
            male: '男',
            female: '女',
            other: '其他',
            yearsOld: '岁',
            parentInfo: '家长信息',
            parentName: '家长姓名',
            parentFirstName: '家长名字',
            parentLastName: '家长姓',
            parentPhone: '家长电话',
            fetchError: '获取学生信息失败',
            exportCSV: '导出学生列表',
        },
        reimbursements: {
            title: '报销记录',
            create: '创建报销记录',
            edit: '编辑报销记录',
            amount: '金额',
            type: '类型',
            description: '描述',
            receipts: '收据',
            receiptsHelp: '请上传发票或收据的照片/扫描件（支持图片和PDF）',
            existingReceipts: '已上传的收据',
            newReceipts: '新上传的收据',
            additionalDocuments: '其他证明文件',
            additionalDocumentsHelp: '可上传其他相关证明文件（支持图片、PDF、Word和Excel文件）',
            createdAt: '申请时间',
            updatedAt: '更新时间',
            reviewedAt: '审核时间',
            paymentDate: '支付时间',
            addNew: '新增报销',
            createFirst: '创建第一条报销记录',
            noRecords: '暂无报销记录',
            fetchError: '获取报销记录失败，请稍后重试',
            submitError: '提交报销申请失败，请稍后重试',
            notFound: '未找到报销记录',
            deleteConfirm: '确定要删除此报销记录吗？',
            deleteSuccess: '删除成功',
            deleteError: '删除失败，请稍后重试',
            viewAll: '查看全部',
            allReimbursements: '全部报销记录',
            filterByStatus: '按状态筛选',
            allStatuses: '全部状态',
            showingReimbursements: '显示 {{start}} 到 {{end}} 条，共 {{total}} 条',
            noReimbursementsWithStatus: '没有{{status}}状态的报销记录',
            status: {
                pending: '待审核',
                approved: '已批准',
                rejected: '已拒绝',
                paid: '已支付'
            },
            types: {
                teaching_materials: '教学材料',
                travel: '差旅费',
                office_supplies: '办公用品',
                equipment: '设备',
                other: '其他'
            },
            noReceipts: '暂无收据',
            reviewComment: '审核意见',
            uploadReceipts: '上传收据',
            uploadDocuments: '上传文档',
            dragAndDrop: '或拖拽文件到此处',
            preview: '预览',
            new: '新',
            existingDocuments: '已上传的文档',
            newDocuments: '新上传的文档',
        },
        attendance: {
            title: '考勤管理',
            records: '考勤记录',
            viewDetails: '查看详情',
            startAttendance: '开始考勤',
            studentName: '学生姓名',
            studentList: '学生列表',
            signInTime: '签到时间',
            signOutTime: '签退时间',
            signInBy: '签到人',
            signOutBy: '签退人',
            status: '状态',
            present: '出席',
            absent: '缺席',
            late: '迟到',
            early: '早退',
            actions: '操作',
            attendees: '出席人员',
            noRecords: '没有找到考勤记录',
            deleteConfirmation: '确定要删除此考勤记录吗？',
            markAsPresent: '标记为出席',
            markAsAbsent: '标记为缺席',
            markAsLate: '标记为迟到',
            markAsEarlyLeave: '标记为早退',
            signIn: '签到',
            signOut: '签退',
            signedIn: '已签到',
            signedOut: '已签退',
            clickToSignIn: '点击进行签到',
            clickToSignOut: '点击进行签退',
            notStarted: '未开始',
            exporting: '导出中...',
            cannotCreateInactive: '已结项的项目不能记录考勤',
            createAttendance: '创建考勤记录',
            createPrompt: '创建自定义考勤记录',
            createdBy: '创建人',
            selectDate: '选择日期',
            exportCsv: '导出为CSV',
            exportRangeCsv: '按时间段导出',
            exportDateRange: '导出时间段考勤',
            startDate: '开始日期',
            endDate: '结束日期',
            noRecordsInRange: '所选时间段内没有考勤记录',
            invalidDateRange: '开始日期不能晚于结束日期',
            goBack: '请返回考勤列表',
            signInDialogTitle: '签到',
            signOutDialogTitle: '签退',
            batchSignIn: '批量签到',
            batchSignInDialogTitle: '批量签到学生',
            selectAll: '全选',
            deselectAll: '全不选',
            selectedCount: '已选择 {count} / {total}',
            allStudentsSignedIn: '所有学生已签到',
            batchSignInConfirm: '签到 {count} 名学生',
            nameLabel: '您的姓名',
            namePlaceholder: '请输入您的姓名',
            detail: {
                status: {
                    present: '已出席',
                    absent: '缺席',
                    late: '迟到',
                    early: '早退'
                }
            },
            confirmDelete: '确认删除',
            deleteWarning: '此操作将永久删除该考勤记录，是否继续？',
            delete: '删除',
            
            // 教师考勤相关翻译
            teacherAttendanceTitle: '教师考勤状态',
            teacherRecords: '教师考勤记录',
            noActivePrograms: '暂无进行中的项目',
            noTeacherRecords: '暂无教师考勤记录',
            noTeachers: '没有找到教师',
            createTeacherAttendance: '创建考勤记录',
            createError: '创建失败',
            notFound: '考勤记录不存在',
            fetchError: '获取数据失败',
            deleteError: '删除失败',
            saveError: '保存失败',
            saveSuccess: '保存成功',
            notesPlaceholder: '输入备注',
            notes: '备注'
        },
        donate: {
            title: '支持我们',
            subtitle: '您的支持是对我们最大的鼓励',
            introduction: {
                title: '为什么您的支持很重要',
                description: '您的慷慨捐赠帮助我们为学生提供优质教育、先进设施和丰富的课程。携手共创一个让每位学生茁壮成长并充分发挥潜能的环境。'
            },
            methods: {
                title: '捐赠方式',
                online: {
                    title: '在线捐赠',
                    description: '使用您的信用卡或PayPal账户进行安全的在线捐赠。'
                },
                check: {
                    title: '支票捐赠',
                    description: '请将支票抬头写为"Great Lakes Academy"并邮寄至：',
                    address: '3300 Plymouth Blvd # 46253 Plymouth，MN 55447'
                },
                bank: {
                    title: '银行转账',
                    description: '进行电汇时，请使用以下银行信息：',
                    details: '银行：第一国家银行\n账户名称：大湖国际学校\n账号：12345678\n路由号码：87654321\nSWIFT代码：FNBGLIS'
                },
                other: {
                    title: '其他捐赠方式',
                    description: '我们还接受证券捐赠、配捐和计划捐赠。欲了解更多信息，请联系我们的捐赠办公室。',
                    contact: '邮箱：donations@greatlake.edu\n电话：(123) 456-7890'
                }
            },
            projects: {
                title: '当前项目',
                description: '您的捐赠可以支持这些重要项目：',
                items: [
                    {
                        title: '奖学金基金',
                        description: '帮助有才华的学生获得教育机会，无论其经济状况如何。',
                        goal: 100000,
                        raised: 65000
                    },
                    {
                        title: '图书馆扩建',
                        description: '支持我们扩展图书馆藏书并创建现代化学习空间的努力。',
                        goal: 50000,
                        raised: 30000
                    },
                    {
                        title: 'STEM创新实验室',
                        description: '为建设科学、技术、工程和数学的先进实验室做出贡献。',
                        goal: 75000,
                        raised: 25000
                    },
                    {
                        title: '艺术项目',
                        description: '帮助通过新设备和机会增强我们的视觉和表演艺术项目。',
                        goal: 40000,
                        raised: 15000
                    }
                ]
            },
            form: {
                title: '立即捐赠',
                fullName: '全名',
                email: '电子邮箱',
                amount: '捐赠金额',
                custom: '自定义金额',
                project: '选择项目',
                recurring: {
                    label: '设为定期捐赠',
                    options: {
                        once: '一次性捐赠',
                        monthly: '每月捐赠',
                        quarterly: '每季度捐赠',
                        annually: '每年捐赠'
                    }
                },
                anonymous: '匿名捐赠',
                comment: '备注（可选）',
                submit: '立即捐赠',
                success: '感谢您的慷慨捐赠！',
                errorMessage: '处理您的捐赠时出现错误。请重试。'
            },
            donors: {
                title: '我们的捐助者',
                subtitle: '我们感谢以下个人和组织的支持',
                anonymous: '匿名捐赠者',
                noData: '暂无捐赠数据',
                categories: {
                    platinum: '铂金捐助者（¥100,000以上）',
                    gold: '黄金捐助者（¥50,000 - ¥99,999）',
                    silver: '白银捐助者（¥10,000 - ¥49,999）',
                    bronze: '铜牌捐助者（¥10,000以下）'
                },
                thankYou: '感谢所有捐赠者的慷慨支持！',
                table: {
                    name: '捐助者',
                    amount: '金额',
                    year: '年份',
                    project: '支持项目',
                    notes: '备注'
                },
                note: '* 仅列出获得许可公开的捐助者信息',
                noNotes: '无备注',
                description: '我们深深感谢以下捐助者的慷慨捐赠。他们的支持使我们能够不断提高教育质量，为学生创造更好的学习环境。'
            },
            faq: {
                title: '常见问题',
                questions: [
                    {
                        question: '我的捐赠可以抵税吗？',
                        answer: '是的，对大湖国际学校的所有捐赠在法律允许的范围内都可以抵税。您将收到一份捐赠收据，可用于纳税目的。'
                    },
                    {
                        question: '我的捐赠将如何使用？',
                        answer: '您的捐赠将按照您的指定用途使用。如果您选择了特定项目，100%的捐赠将用于该计划。未指定用途的捐赠将用于最需要的地方。'
                    },
                    {
                        question: '我可以进行定期捐赠吗？',
                        answer: '是的，您可以设置每月、每季度或每年的定期捐赠。这是一种为我们学校提供持续支持的便捷方式。'
                    },
                    {
                        question: '如何更改我的定期捐赠？',
                        answer: '您可以通过联系我们的捐赠办公室（邮箱：donations@greatlake.edu）或致电(123) 456-7890来更改您的定期捐赠。'
                    },
                    {
                        question: '我可以为纪念或荣誉某人而捐赠吗？',
                        answer: '是的，您可以进行纪念或荣誉捐赠。只需在捐赠表格的备注部分包含您要纪念的人的姓名即可。'
                    }
                ]
            },
            events: {
                title: '筹款活动',
                description: '我们欢迎社区伙伴参与我们的筹款活动。活动包括：',
                noData: '目前没有筹款活动。',
                type1: '慈善晚宴或庆典',
                type2: '慈善拍卖（现场或无声拍卖）',
                type3: '步行马拉松/趣味跑',
                type4: '音乐会、表演或文化节',
                type5: '在线筹款活动/直播',
                type6: '节日市场/手工艺品展'
            }
        },
        contact: {
            title: '联系我们',
            subtitle: '我们期待您的来信',
            form: {
                title: '发送消息',
                name: '您的姓名',
                email: '电子邮箱',
                phone: '电话号码',
                subject: '主题',
                message: '您的消息',
                submit: '发送消息',
                success: '您的消息已成功发送！',
                error: '发送消息时出现错误。请重试。'
            },
            info: {
                title: '联系信息',
                address: {
                    title: '邮件地址',
                    line1: '3300 Plymouth Blvd',
                    line2: '# 46253',
                    line3: 'Plymouth, MN 55447, United States'
                },
                phone: {
                    title: '电话',
                    main: '总办公室：(123) 456-7890',
                    admissions: '招生办公室：(123) 456-7891',
                    support: '技术支持：(123) 456-7892'
                },
                email: {
                    title: '电子邮箱',
                    general: 'info@greatlake.edu',
                    admissions: 'admissions@greatlake.edu',
                    support: 'support@greatlake.edu'
                },
                hours: {
                    title: '办公时间',
                    weekdays: '周一至周五：上午8:00 - 下午5:00',
                    weekend: '周六：上午9:00 - 中午12:00',
                    closed: '周日：休息'
                }
            },
            directoryHeading: '教职员工名录',
            formValidation: {
                nameRequired: '请输入您的姓名',
                emailRequired: '请输入您的电子邮箱',
                emailInvalid: '请输入有效的电子邮箱',
                phoneRequired: '请输入您的电话号码',
                phoneInvalid: '请输入有效的电话号码',
                subjectRequired: '请输入主题',
                messageRequired: '请输入您的消息'
            }
        },
        teachers: {
            title: '精英团队',
            subtitle: '万湖书院拥有一支专业、敬业、充满热情的管理和教师团队',
            introduction: {
                title: '管理和教师团队',
                paragraph1: '万湖书院拥有一支经验丰富、充满热情的管理与教师团队。我们的核心成员由深耕中文教育多年的资深教育专家组成，他们不仅具备扎实的专业背景，更熟悉K-12学生的学习特点。管理团队注重科学化、人性化的办学理念，致力于为师生和家长提供优质的教育服务，营造积极向上的学习社区。 ',
                paragraph2: '教师团队是我们的核心力量，既有在美任教数十年的中文教育骨干，也有具备最新视野的青年教师。所有教师均受过高等教育，并定期参与教学培训和学术交流，确保教学理念与方法与时俱进。我们以耐心、责任心和创新精神，帮助学生在语言及拓展学科学习中取得进步。 ',
                paragraph3: '我们相信，教育不仅是知识的传递，更是心灵的启迪。万湖书院的教师们不仅教授知识，更关注每个学生的个性发展，通过丰富的文化活动和互动课堂，激发学生对学习的兴趣。我们以专业、温暖和持续进步的态度，陪伴学生成长，助力他们在多元文化环境中自信前行。'
            },
            searchPlaceholder: '搜索教师姓名、职称或简介',
            departmentFilter: '部门筛选',
            noResults: '没有找到匹配的教师，请尝试其他筛选条件',
            education: '教育背景',
            specialties: '教授课程',
            contact: '联系方式',
            joinUs: {
                title: '加入我们的团队',
                description: '万湖书院始终欢迎优秀的教育工作者加入我们的团队。如果您热爱教育，有创新精神，并希望在一个充满活力的环境中工作，请与我们联系。',
                contactUs: '联系我们'
            },
            viewDetails: '了解更多'
        },
        about: {
            title: '关于万湖书院',
            subtitle: '培养未来的领袖，传承中华文化精髓',
            introduction: {
                title: '学校简介',
                paragraph1: '万湖书院（GLA） 是一个非营利性教育和文化组织，于 2025 年在明尼苏达州成立。我们的使命是提供高质量的教育计划和文化丰富机会，以促进学术卓越、领导力发展、全球公民意识和社区参与。',
                paragraph2: '万湖书院提供持续和系统的教育项目，包括中文语言、文化、数学和其他学术科目，帮助学生为未来的成功做好准备。我们的项目促进文化交流，鼓励社区参与，加强社会责任感和对多样性的欣赏。',
                paragraph3: '多年来，万湖书院已经培养了数千名优秀毕业生，他们在各自的领域取得了卓越的成就，成为了社会的栋梁。',
                imageAlt: '万湖书院校园'
            },
            history: {
                title: '历史沿革',
                2010: '万湖书院正式成立，首批招收学生50名。',
                2013: '扩建校园，增设艺术中心和科学实验室。',
                2015: '首届毕业生全部被国内外知名大学录取。',
                2018: '获得"全国优秀教育机构"称号。',
                2020: '建校十周年，举办盛大庆典，并启动"未来十年"发展计划。',
                2023: '成立国际交流中心，与多所国际知名学校建立合作关系。'
            },
            campus: {
                title: '校园环境',
                image1Alt: '校园风景',
                image1Title: '优美环境',
                image1Text: '我们的校园坐落在湖畔，环境优美，绿树成荫，为学生提供了一个宁静、舒适的学习环境。',
                image2Alt: '现代教室',
                image2Title: '现代设施',
                image2Text: '配备了先进的教学设施和技术，包括智能教室、多媒体实验室和图书馆。',
                image3Alt: '活动中心',
                image3Title: '活动空间',
                image3Text: '设有多功能活动中心、体育场馆和艺术表演中心，满足学生多样化的兴趣和需求。'
            }
        },
        calendar: {
            title: '校历',
            subtitle: '了解学校日程安排，不错过重要活动',
            error: {
                fetch: '获取校历数据失败'
            },
            noCalendars: '暂无校历',
            uploadDate: '上传日期',
            download: '下载校历',
            status: {
                active: '已发布',
                draft: '草稿',
                archived: '已归档'
            },
            filter: {
                all: '全部',
                active: '已发布',
                draft: '草稿',
                archived: '已归档'
            },
            preview: {
                title: '预览校历',
                close: '关闭预览'
            }
        },
        news: {
            title: '新闻',
            subtitle: '发挥新闻正确导向，充分了解我们与世界',
            categories: {
                all: '综合',
                news: '新闻动态',
                notice: '通知公告'
            },
            pagination: {
                previous: '上一页',
                next: '下一页'
            },
            empty: '暂无文章',
            unpublished: '未发布',
            backToList: '返回列表'
        },
        article: {
            notFound: '文章不存在',
            backToList: '返回列表'
        }
    }
}; 
